export const PHONE_MAX_WIDTH = 450;
export const PHONE_FOLD_MAX_WIDTH = 890;
export const PAD_MAX_WIDTH = 1080;
export const SLIDER_SIZE_RATE = 1;
// 90 / 343;
export const UPWIDGET_HEIGHT = 44 + 12;
